/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S11_P3Inputs */

const tr_kullanim_s11_p3 = /** @type {(inputs: Kullanim_S11_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, Müşteri İçeriği üzerinde mülkiyet hakkı iddia etmez ve bu içeriği yalnızca Hizmet'in ifası için gerekli olan ölçüde işler.`)
};

const en_kullanim_s11_p3 = /** @type {(inputs: Kullanim_S11_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider claims no ownership right over the Customer Content and processes this content only to the extent necessary for the performance of the Service.`)
};

const de_kullanim_s11_p3 = /** @type {(inputs: Kullanim_S11_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter erhebt keinen Eigentumsanspruch auf die Kundeninhalte und verarbeitet diese nur in dem Umfang, der für die Erbringung des Dienstes erforderlich ist.`)
};

const ru_kullanim_s11_p3 = /** @type {(inputs: Kullanim_S11_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик не заявляет права собственности на Контент клиента и обрабатывает этот контент только в объёме, необходимом для оказания Услуги.`)
};

/**
* | output |
* | --- |
* | "The Provider claims no ownership right over the Customer Content and processes this content only to the extent necessary for the performance of the Service." |
*
* @param {Kullanim_S11_P3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s11_p3 = /** @type {((inputs?: Kullanim_S11_P3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S11_P3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s11_p3(inputs)
	if (locale === "de") return de_kullanim_s11_p3(inputs)
	if (locale === "ru") return ru_kullanim_s11_p3(inputs)
	return tr_kullanim_s11_p3(inputs)
});